import React, { useContext } from "react";
import { Card, Accordion, useAccordionButton, AccordionContext } from "react-bootstrap";
import "./index.css";
import CustomButton from "../../common/CustomButton";
import { stringConstants } from "../../../helpers/app-constants";
import "bootstrap-icons/font/bootstrap-icons.css";

const AdminPlaneMenu = ({ auth, dispatch, handlePanelMenuClose, scrollRef, OnMenuClicked }) => {
  const CustomToggle = ({ children, eventKey }) => {
    const { activeEventKey } = useContext(AccordionContext);

    // check if this item is active
    const isCurrentEventKey = activeEventKey === eventKey;
    const decoratedOnClick = useAccordionButton(eventKey);

    return (
      <CustomButton
        // eventKey="1"
        onClick={decoratedOnClick}
        buttonClasses="menu-btn w-100 py-3 "
      >
        {children}
        {/* toggle caret based on open/close */}
        <i className={`bi ${isCurrentEventKey ? "bi-caret-down-fill" : "bi-caret-right-fill"}`}></i>
      </CustomButton>
    );
  };

  // const OnMenuClicked = (setState) => {
  //   dispatch(setState);
  //   handlePanelMenuClose();
  // };

  const handleScrollView = (index) => {
    scrollRef.current[index]?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const bhareeAdminMenu = () => {
    return (
      <>
        <CustomButton
          buttonClasses="menu-btn w-100 py-3 "
          onClick={() => {
            OnMenuClicked({
              type: stringConstants.SET_CURRENT_VIEW,
              payload: stringConstants.DASHBOAD,
            });
          }}
        >
          <i class="bi bi-laptop"></i>
          <span>{"Dashboard"}</span>
        </CustomButton>

        {/* Accepted Enquiries Section */}
        <CustomButton
          buttonClasses="menu-btn w-100 py-3 "
          style={{ textAlign: "left" }}
          onClick={() =>
            OnMenuClicked({
              type: stringConstants.SET_CURRENT_VIEW,
              payload: stringConstants.MY_ENQUIRIES,
            })
          }
        >
          <i class="bi bi-question-circle"></i>
          <span>{"Enquiries"}</span>
        </CustomButton>

        {/* Accepted Orders Section */}
        <CustomButton
          buttonClasses="menu-btn w-100 py-3 "
          style={{ textAlign: "left" }}
          onClick={() =>
            OnMenuClicked({
              type: stringConstants.SET_CURRENT_VIEW,
              payload: stringConstants.MY_ORDERS,
            })
          }
        >
          <i class="bi bi-boxes"></i>
          <span>{"Orders"}</span>
        </CustomButton>

        {/* Profile Section */}
        {auth?.user?.roles_type?.role_type_name === stringConstants.ROLL_TYPE_SUPER_ADMIN && (
          <Accordion>
            <CustomToggle eventKey="0">
              <i class="bi bi-person"></i>
              <span>{"Profile"}</span>
            </CustomToggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body className="py-4">
                <CustomButton
                  buttonClasses="sub-menu-btn w-100"
                  onClick={() => {
                    OnMenuClicked({
                      type: stringConstants.SET_CURRENT_VIEW,
                      payload: stringConstants.BASIC_INFORMATION,
                    });
                  }}
                >
                  <span>{"Basic Info"}</span>
                </CustomButton>
              </Card.Body>
            </Accordion.Collapse>
          </Accordion>
        )}

        {/* Settings Section */}
        {auth?.user?.roles_type?.role_type_name === stringConstants.ROLL_TYPE_SUPER_ADMIN && (
          <Accordion>
            <CustomToggle eventKey="0">
              <i class="bi bi-gear"></i>
              <span>{"Settings"}</span>
            </CustomToggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body className="py-0">
                <CustomButton
                  buttonClasses="sub-menu-btn w-100 py-2 "
                  onClick={() => {
                    OnMenuClicked({
                      type: stringConstants.SET_CURRENT_VIEW,
                      payload: stringConstants.BRANDS,
                    });
                  }}
                >
                  <span>{"Brands"}</span>
                </CustomButton>
                <CustomButton
                  buttonClasses="sub-menu-btn w-100 py-2 "
                  onClick={() => {
                    OnMenuClicked({
                      type: stringConstants.SET_CURRENT_VIEW,
                      payload: stringConstants.PRODUCTS,
                    });
                  }}
                >
                  <span>{"Products"}</span>
                </CustomButton>
                <CustomButton
                  buttonClasses="sub-menu-btn w-100 py-2 "
                  onClick={() => {
                    OnMenuClicked({
                      type: stringConstants.SET_CURRENT_VIEW,
                      payload: stringConstants.BASICS,
                    });
                  }}
                >
                  <span>{"Basics"}</span>
                </CustomButton>
                <CustomButton
                  buttonClasses="sub-menu-btn w-100 py-2 "
                  onClick={() => {
                    OnMenuClicked({
                      type: stringConstants.SET_CURRENT_VIEW,
                      payload: stringConstants.SERVICE_TAX_DETAILS,
                    });
                  }}
                >
                  <span>{"Service Tax"}</span>
                </CustomButton>
              </Card.Body>
            </Accordion.Collapse>
          </Accordion>
        )}

        {/* Users List */}
        <Accordion>
          <CustomToggle eventKey="0">
            <i class="bi bi-person"></i>
            <span>{"Users"}</span>
          </CustomToggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="py-4">
              <CustomButton
                buttonClasses="sub-menu-btn w-100"
                onClick={() => {
                  OnMenuClicked({
                    type: stringConstants.SET_CURRENT_VIEW,
                    payload: stringConstants.USER_SELLERS,
                  });
                }}
              >
                <span>{"Sellers"}</span>
              </CustomButton>
              <CustomButton
                buttonClasses="sub-menu-btn w-100"
                onClick={() => {
                  OnMenuClicked({
                    type: stringConstants.SET_CURRENT_VIEW,
                    payload: stringConstants.USER_BUYERS,
                  });
                }}
              >
                <span>{"Buyers"}</span>
              </CustomButton>
              {auth?.user?.roles_type?.role_type_name === stringConstants.ROLL_TYPE_SUPER_ADMIN && (
                <CustomButton
                  buttonClasses="sub-menu-btn w-100"
                  onClick={() => {
                    OnMenuClicked({
                      type: stringConstants.SET_CURRENT_VIEW,
                      payload: stringConstants.USER_EMPLOYEES,
                    });
                  }}
                >
                  <span>{"Employees"}</span>
                </CustomButton>
              )}
              <CustomButton
                buttonClasses="sub-menu-btn w-100"
                onClick={() => {
                  OnMenuClicked({
                    type: stringConstants.SET_CURRENT_VIEW,
                    payload: stringConstants.USER_LP,
                  });
                }}
              >
                <span>{"LP"}</span>
              </CustomButton>
            </Card.Body>
          </Accordion.Collapse>
        </Accordion>
        <CustomButton
  buttonClasses="menu-btn w-100 py-3"
  onClick={() => {
    OnMenuClicked({
      type: stringConstants.SET_CURRENT_VIEW,
      payload: stringConstants.REFERRAL_HISTORY,
    });
  }}
>
  <i className="bi bi-person-plus"></i>
  <span>{"Referral History"}</span>
</CustomButton>

        {/* Reports Section */}
        <CustomButton
          buttonClasses="menu-btn w-100 py-3"
          onClick={() => {
            OnMenuClicked({
              type: stringConstants.SET_CURRENT_VIEW,
              payload: stringConstants.REPORTS,
            });
          }}
        >
          <i class="bi bi-clipboard-data"></i>
          <span>{"Reports"}</span>
        </CustomButton>
      </>
    );
  };

  const sellerAdminMenu = () => {
    return (
      <>
        <CustomButton
          buttonClasses="menu-btn w-100 py-3 "
          onClick={() => {
            OnMenuClicked({
              type: stringConstants.SET_CURRENT_VIEW,
              payload: stringConstants.DASHBOAD,
            });
          }}
        >
          <i class="bi bi-laptop"></i>
          <span>{"Dashboard"}</span>
        </CustomButton>
     

        {auth.user.onboarding && (
          <>
            {" "}
            <CustomButton
              buttonClasses="menu-btn w-100 py-3 "
              onClick={() => {
                OnMenuClicked({
                  type: stringConstants.SET_CURRENT_VIEW,
                  payload: stringConstants.MY_ENQUIRIES,
                });
              }}
            >
              <i className="bi bi-question-circle"></i>
              <span>{"Enquiries"}</span>
            </CustomButton>
            {auth?.user?.app_features !== "leads" && (
              <CustomButton
                buttonClasses="menu-btn w-100 py-3 "
                onClick={() => {
                  OnMenuClicked({
                    type: stringConstants.SET_CURRENT_VIEW,
                    payload: stringConstants.MY_ORDERS,
                  });
                }}
              >
                <i className="bi bi-boxes"></i>
                <span>{"Orders"}</span>
              </CustomButton>
            )}
            <CustomButton
              buttonClasses="menu-btn w-100 py-3 "
              onClick={() => {
                OnMenuClicked({
                  type: stringConstants.SET_CURRENT_VIEW,
                  payload: stringConstants.MY_SUBSCRIPTIONS,
                });
              }}
            >
              <i className="bi bi-currency-rupee"></i>
              <span>{"Plan"}</span>
            </CustomButton>
            {auth?.user?.app_features !== "leads" && (
              <CustomButton
                buttonClasses="menu-btn w-100 py-3 "
                onClick={() => {
                  OnMenuClicked({
                    type: stringConstants.SET_CURRENT_VIEW,
                    payload: stringConstants.MY_INVOICES,
                  });
                }}
              >
                <i className="bi bi-currency-rupee"></i>
                <span>{"Invoices"}</span>
              </CustomButton>
              
            )}
               {/* Referral */}
<CustomButton
  buttonClasses="menu-btn w-100 py-3 "
  onClick={() => {
    OnMenuClicked({
      type: stringConstants.SET_CURRENT_VIEW,
      payload: stringConstants.REFERRAL,
    });
  }}
>
  <i className="bi bi-person-plus"></i>
  <span>{"Referral"}</span>
</CustomButton>

<CustomButton
  buttonClasses="menu-btn w-100 py-3 "
  onClick={() => {
    OnMenuClicked({
      type: stringConstants.SET_CURRENT_VIEW,
      payload: stringConstants.REFERRAL_HISTORY,
    });
  }}
>
  <i className="bi bi-clock-history"></i>
  <span>{"Referral History"}</span>
</CustomButton>
            {/* Business Info */}
            <Accordion>
              <CustomToggle eventKey="0">
                <i class="bi bi-person"></i>
                <span>{"Business Info"}</span>
              </CustomToggle>
              <Accordion.Collapse eventKey="0">
                <Card.Body className="py-4">
                  <CustomButton
                    buttonClasses="sub-menu-btn w-100"
                    onClick={() => {
                      OnMenuClicked({
                        type: stringConstants.SET_CURRENT_VIEW,
                        payload: stringConstants.COMPANY_INFORMATION,
                      });
                    }}
                  >
                    <span>{"Company Info"}</span>
                  </CustomButton>

                  <CustomButton
                    buttonClasses="sub-menu-btn w-100"
                    onClick={() => {
                      OnMenuClicked({
                        type: stringConstants.SET_CURRENT_VIEW,
                        payload: stringConstants.BANKING_AND_TAXATION,
                      });
                    }}
                  >
                    <span>{"Banking info"}</span>
                  </CustomButton>
                  {auth.user?.roles_type?.role_type_name ===
                    stringConstants.ROLL_TYPE_MANUFACTURER && (
                    <CustomButton
                      buttonClasses="sub-menu-btn w-100"
                      onClick={() => {
                        OnMenuClicked({
                          type: stringConstants.SET_CURRENT_VIEW,
                          payload: stringConstants.FACTORY_INFO,
                        });
                      }}
                    >
                      <span>{"factory info"}</span>
                    </CustomButton>
                  )}
                  <CustomButton
                    buttonClasses="sub-menu-btn w-100"
                    onClick={() => {
                      OnMenuClicked({
                        type: stringConstants.SET_CURRENT_VIEW,
                        payload: stringConstants.ADDRESS,
                      });
                    }}
                  >
                    <span>{"Address"}</span>
                  </CustomButton>
                  <CustomButton
                    buttonClasses="sub-menu-btn w-100"
                    onClick={() => {
                      OnMenuClicked({
                        type: stringConstants.SET_CURRENT_VIEW,
                        payload: stringConstants.LOGISTIC_PARTNER,
                      });
                    }}
                  >
                    <span>{"LP"}</span>
                  </CustomButton>
                </Card.Body>
              </Accordion.Collapse>
            </Accordion>
            {/* Settings */}
            <Accordion>
              <CustomToggle eventKey="0">
                <i class="bi bi-gear"></i>
                <span>{"Product Info"}</span>
              </CustomToggle>
              <Accordion.Collapse eventKey="0">
                <Card.Body className="py-4">
                  <CustomButton
                    buttonClasses="sub-menu-btn w-100"
                    onClick={() => {
                      OnMenuClicked({
                        type: stringConstants.SET_CURRENT_VIEW,
                        payload: stringConstants.BRANDS,
                      });
                    }}
                  >
                    <span>{"Brands"}</span>
                  </CustomButton>
                  <CustomButton
                    buttonClasses="sub-menu-btn w-100"
                    onClick={() => {
                      OnMenuClicked({
                        type: stringConstants.SET_CURRENT_VIEW,
                        payload: stringConstants.PRODUCTS,
                      });
                    }}
                  >
                    <span>{"Products"}</span>
                  </CustomButton>
                  <CustomButton
                    buttonClasses="sub-menu-btn w-100"
                    onClick={() => {
                      OnMenuClicked({
                        type: stringConstants.SET_CURRENT_VIEW,
                        payload: stringConstants.VARIANTS,
                      });
                    }}
                  >
                    <span>{"VARIANTS"}</span>
                  </CustomButton>
                  <CustomButton
                    buttonClasses="sub-menu-btn w-100"
                    onClick={() => {
                      OnMenuClicked({
                        type: stringConstants.SET_CURRENT_VIEW,
                        payload: stringConstants.LIVE_OFFERS,
                      });
                    }}
                  >
                    <span>{"LIVE OFFERS"}</span>
                  </CustomButton>
                </Card.Body>
              </Accordion.Collapse>
            </Accordion>
            {/* Cost Calculations */}
          {/*  {auth?.user?.roles_type?.role_type_name === stringConstants.ROLL_TYPE_MANUFACTURER && (
              <CustomButton
                buttonClasses="menu-btn w-100 py-3"
                onClick={() => {
                  OnMenuClicked({
                    type: stringConstants.SET_CURRENT_VIEW,
                    payload: stringConstants.COST_CALCULATIONS,
                  });
                }}
              >
                <i className="bi bi-calculator"></i>
                <span>{"Calculations"}</span>
              </CustomButton>
            )}
              */}
            {/* Reports */}
            <Accordion>
              <CustomToggle eventKey="0">
                <i class="bi bi-clipboard-data"></i>
                <span>{"Reports"}</span>
              </CustomToggle>
              <Accordion.Collapse eventKey="0">
                <Card.Body className="py-4">
                  {auth?.user?.app_features !== "leads" && (
                    <CustomButton
                      buttonClasses="sub-menu-btn w-100"
                      onClick={() => {
                        OnMenuClicked({
                          type: stringConstants.SET_CURRENT_VIEW,
                          payload: stringConstants.SALES_REPORT,
                        });
                      }}
                    >
                      <span>{"Total Sales"}</span>
                    </CustomButton>
                  )}
                  <CustomButton
                    buttonClasses="sub-menu-btn w-100"
                    onClick={() => {
                      OnMenuClicked({
                        type: stringConstants.SET_CURRENT_VIEW,
                        payload: stringConstants.ENQUIRY_REPORT,
                      });
                    }}
                  >
                    <span>{"Total Enquiries"}</span>
                  </CustomButton>
                </Card.Body>
              </Accordion.Collapse>
            </Accordion>
          </>
        )}
      </>
    );
  };

  const logisticAdminMenu = () => {
    return (
      <>
        <CustomButton
          buttonClasses="menu-btn w-100 py-3 "
          onClick={() => {
            OnMenuClicked({
              type: stringConstants.SET_CURRENT_VIEW,
              payload: stringConstants.DASHBOAD,
            });
          }}
        >
          <i class="bi bi-laptop"></i>
          <span>{"Dashboard"}</span>
        </CustomButton>
        {/* Settings */}
        <CustomButton
          buttonClasses="menu-btn w-100 py-3 "
          onClick={() => {
            OnMenuClicked({
              type: stringConstants.SET_CURRENT_VIEW,
              payload: stringConstants.LOGISTIC_PARTNER_SETTINGS,
            });
          }}
        >
          <i class="bi bi-gear"></i>
          <span>{"Settings"}</span>
        </CustomButton>
        <Accordion>
          <CustomToggle eventKey="0">
            <i class="bi bi-gear"></i>
            <span>{"Reports"}</span>
          </CustomToggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="py-4">
              <CustomButton
                buttonClasses="sub-menu-btn w-100"
                onClick={() => {
                  OnMenuClicked({
                    type: stringConstants.SET_CURRENT_VIEW,
                    payload: stringConstants.LOGISTIC_MONTHLY_TRIP,
                  });
                }}
              >
                <span>{"Total Trips"}</span>
              </CustomButton>
              {/* <CustomButton
                buttonClasses="sub-menu-btn w-100"
                onClick={() => {
                  OnMenuClicked({
                    type: stringConstants.SET_CURRENT_VIEW,
                    payload: stringConstants.LOGISTIC_SELLER_TRIP,
                  });
                }}
              >
                <span>{"Trip By Seller"}</span>
              </CustomButton> */}
            </Card.Body>
          </Accordion.Collapse>
        </Accordion>
      </>
    );
  };

  return (
    <div className="admion-plane-menu-div">
      {(() => {
        if (auth.user?.role?.role_name === stringConstants.ROLL_BHAREE) {
          return bhareeAdminMenu();
        } else if (auth.user?.role?.role_name === stringConstants.ROLL_SELLER) {
          return sellerAdminMenu();
        } else if (auth.user?.role?.role_name === stringConstants.ROLL_LOGISTIC_PARTNER) {
          return logisticAdminMenu();
        }
      })()}
    </div>
  );
};

export default AdminPlaneMenu;
